import React, { Component } from 'react';
import { Card, Table, Modal, Button, Input, Form } from 'antd';
import {
    storyMoneyAdd,
    storyMoneyDelete,
    storyMoneyDeletes,
    storyMoneyListInitDataSource,
    storyMoneyUpdate
} from "../actions/storyMoneyList";

const start = 1;//从1第一页开始
const size = 10;//每页10条

/** 列表 */
class StoryMoneyList extends Component {
	columns = [
		{
    		title: '人员',
		    dataIndex: 'account',
		    key: 'account',
			render: (text, record) => (
				<a onClick={()=>this.updateStoryMoney(record)}>{text}</a>
			),
		},   
		{
			title: '金额',
			dataIndex: 'money',
			key: 'money'
		},
		{
			title: '稿件标题',
			dataIndex: 'storyTitle',
			key: 'storyTitle'
		},
		{
			title: '创建时间',
			dataIndex: 'createDate',
			key: 'createDate'
		},
		{
			title: '操作',
			key: 'action',
			render: (text, record) => (
				<span>
					<Button type="primary" onClick={()=>this.updateStoryMoney(record)}>修改</Button>
					<Button type="danger" style={{marginLeft:"10px"}} onClick={()=>this.deleteStoryMoney([record])}>删除</Button>
				</span>
			),
		}
	];

    state = {
        start : start,
        size : size,
        total: 0,
        selectedRows:[],
        data: []
    };

    initDataSource = (page, pageSize) => this.paginationOnChange(page, pageSize);

    paginationOnChange(page, pageSize){
        storyMoneyListInitDataSource(page, pageSize, (res)=>{
            this.setState(prevState => {
                return {
                    ...prevState,
                    start : page,
                    size : pageSize,
                    total: res.count,
                    data: (()=>{
                        for(let i = 0; res.data && i < res.data.length; i++){
                            //这个key是react的item必须的，如果没有这会按照索引来。但是复选框就会出问题了。
                            //当选择了某个选项，再翻页后，会将新页码中的数据也选中
                            if(!res.data[i].key){
                                res.data[i].key = res.data[i].id;
                            }
                        }
                        return res.data;
                    })(),
                    selectedRows:[]
                }
            })
        });
    }

    componentDidMount() {
        this.initDataSource(this.state.start, this.state.size);
    }

    onSelect = (record, selected, selectedRows, nativeEvent)=>{
        this.setState({
            selectedRows: selectedRows
        })
    };

    onSelectAll = (selected, selectedRows, changeRows) => {
        this.setState({
            selectedRows: selectedRows
        })
    };

    updateStoryMoney = (storyMoney) => {
        this.refs.storyMoneyModal.showModal("修改", storyMoney, storyMoneyUpdate, ()=>{
            this.paginationOnChange(this.state.start, this.state.size);
        });
    };

    addStoryMoney = () => {
        this.refs.storyMoneyModal.showModal("新增", null, storyMoneyAdd, ()=>{
            this.paginationOnChange(this.state.start, this.state.size);
        });
    };

    deleteStoryMoney = (selectedRows) => {
        let that = this;
        if(!selectedRows || selectedRows.length === 0){
            Modal.error({
                title: '请选择要删除的项',
                okText:"确定"
            });
            return;
        }
        Modal.confirm({
            title: '删除稿费',
            content: '删除后无法恢复，确定删除？',
            okText: '确认',
            cancelText: '取消',
            onOk: ()=>{
                let ids = [];
                for(let i = 0; selectedRows && i < selectedRows.length; i ++){
                    let id = selectedRows[i].id;
                    ids.push(id);
                }
                if(ids && ids.length === 1){
                    storyMoneyDelete({id:ids[0]},()=>{
                        //如果当前页不是第一页且是最后一页，并且这页的数据和删除的数据长度一样。
                        //那么页码就得往前翻一页
                        if(ids.length === that.state.data.length
                            && Math.ceil(that.state.total / that.state.size) === this.state.start
                            && this.state.start != 1){
                            this.paginationOnChange(that.state.start - 1, that.state.size);
                        }else{
                            this.paginationOnChange(that.state.start, that.state.size);
                        }
                    });
                    that.setState(prevState =>{
                        let tempSelectedRows = [];
                        for(let j = 0; prevState.selectedRows && j < prevState.selectedRows.length; j ++){
                            let row = prevState.selectedRows[j];
                            if(row.id !== ids[0]){
                                tempSelectedRows.push(row);
                            }
                        }
                        return {
                            ...prevState,
                            selectedRows:tempSelectedRows
                        };
                    })
                }else if(ids && ids.length > 1){
                    storyMoneyDeletes(ids,()=>{
                        //如果当前页不是第一页且是最后一页，并且这页的数据和删除的数据长度一样。
                        //那么页码就得往前翻一页
                        if(ids.length === that.state.data.length
                            && Math.ceil(that.state.total / that.state.size) === this.state.start
                            && this.state.start != 1){
                            this.paginationOnChange(that.state.start - 1, that.state.size);
                        }else{
                            this.paginationOnChange(that.state.start, that.state.size);
                        }
                    });
                    that.setState({
                        selectedRows:[]
                    });
                }
            }
        });
    };

    //获取选中的项，用于回显
    getSelectedRowKeys = ()=>{
        let selectedRowKeys = [];
        for(let j = 0; this.state.selectedRows && j < this.state.selectedRows.length; j ++){
            let row = this.state.selectedRows[j];
            selectedRowKeys.push(row.key);
        }
        return selectedRowKeys;
    };

    render() {
        const margin = 15;
        const type = "checkbox";//也可以是radio
        let pagination = {
            onChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            onShowSizeChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            defaultCurrent: 1,
            defaultPageSize: 10,
            current: this.state.start,
            pageSize: this.state.size,
            total: this.state.total,
            showQuickJumper: true, //快速跳转至某一页
            showSizeChanger: true,	//是否可以改变 pageSize
        };
        let selectedRowKeys = this.getSelectedRowKeys();
        return (
            <Card title={<span style={{fontSize: "14px"}}>稿费列表</span>} style={{ width: "calc(100% - "+margin*2+"px)", margin: margin + "px"}}>
                <Button type="primary" onClick={()=>this.addStoryMoney()}>新增</Button>
                <Button type="danger" style={{marginLeft:"10px",marginBottom:"20px"}} onClick={()=>this.deleteStoryMoney(this.state.selectedRows)}>批量删除</Button>
                <StoryMoneyModal ref={"storyMoneyModal"} />
                <Table columns={this.columns} dataSource={this.state.data} pagination={pagination}
                       rowSelection={{
                           selectedRowKeys: selectedRowKeys,
                           onSelect: this.onSelect,
                           onSelectAll: this.onSelectAll,
                           type: type
                       }}
                       bordered={true}//是否展示外边框和列边框
                       size={"small"}/>
            </Card>
        );
    }
}

/** 弹窗 */
class StoryMoneyModal extends React.Component{

    state = {
        title: "信息",
        visible: false,
        fieldData: {},
        confirmLoading: false,
    };

    closeBallBack(){

    };
    okCallBack(){

    };

    showModal = (title, fieldData, okCallBack, closeCallBack) => {
        this.setState({
            title: title,
            visible: true,
            fieldData: (()=>{
                if(!fieldData){
                    return null;
                }
                let value = {};
                for(let attr in fieldData){
                    value[attr] = {
                        value: fieldData[attr]
                    }
                }
                return value;
            })()
        });
        this.okCallBack = okCallBack;
        this.closeBallBack = closeCallBack;
    };

    handleOk = (e) => {
        this.setState({
            confirmLoading: true,
        });

        let that = this;
        let wrappedStoryMoneyModalForm = this.refs.wrappedStoryMoneyModalForm;//通过refs属性可以获得对话框内form对象
        wrappedStoryMoneyModalForm.validateFields((err, values) => {
            if(!err){
                that.okCallBack(values, function(){
                    that.setState({
                        visible: false,
                        confirmLoading: false,
                    });
                    wrappedStoryMoneyModalForm.resetFields();
                    if(that.closeBallBack){
                        that.closeBallBack();
                    }
                });
            }else{
                this.setState({
                    confirmLoading: false,
                });
            }
        });
    };

    handleCancel = () => {
        let wrappedStoryMoneyModalForm = this.refs.wrappedStoryMoneyModalForm;
        wrappedStoryMoneyModalForm.resetFields();
        this.setState({
            visible: false,
        });
    };

    render() {
        const { visible, confirmLoading } = this.state;
        return (
            <Modal
                title={this.state.title}
                visible={visible}
                onOk={this.handleOk}
                okText={"确定"}
                maskClosable={true}
                cancelText={"取消"}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
            >
                <WrappedStoryMoneyModalForm fieldData={this.state.fieldData} ref={"wrappedStoryMoneyModalForm"} />
            </Modal>
        );
    }
}

/** 表单 */
class StoryMoneyModalForm extends React.Component{

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    fieldData;

    initFields(props) {
        const { fieldData } = props;
        const { setFields } = props.form;
        if(fieldData && this.fieldData !== fieldData){
            this.fieldData = fieldData;
            setFields(fieldData);
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        return (
            <Form {...formItemLayout}>
                {getFieldDecorator('id',{
                    initialValue:0
                })(
                    <Input type={"hidden"} />
                )}
					<Form.Item label="人员">
                    {getFieldDecorator('account', {
                        rules: [{ required: true, message: '请输入人员!' }],
                    })(
                        <Input placeholder="请输入人员" />
                    )}
                </Form.Item>
					<Form.Item label="金额">
                    {getFieldDecorator('money', {
                        rules: [{ required: true, message: '请输入金额!' }],
                    })(
                        <Input placeholder="请输入金额" />
                    )}
                </Form.Item>
					<Form.Item label="稿件标题">
                    {getFieldDecorator('storyTitle', {
                        rules: [{ required: true, message: '请输入稿件标题!' }],
                    })(
                        <Input placeholder="请输入稿件标题" />
                    )}
                </Form.Item>
					<Form.Item label="创建时间">
                    {getFieldDecorator('createDate', {
                        rules: [{ required: true, message: '请输入创建时间!' }],
                    })(
                        <Input placeholder="请输入创建时间" />
                    )}
                </Form.Item>
            </Form>
        );
    }
}

const WrappedStoryMoneyModalForm = Form.create()(StoryMoneyModalForm);

export default StoryMoneyList;